$(document).ready(function(){
  for (var i = 0; i < carmakes.length; i++)
  {
    var obj = carmakes[i].make_display;
    var obj_id = carmakes[i].make_id;
    $('select#make').append($("<option></option>").attr("value",obj_id).text(obj)); 
  }
});

var carmakes =
[
{
  "make_id": "abarth",
  "make_display": "Abarth",
  "make_country": "Italy"
},
{
  "make_id": "ac",
  "make_display": "AC",
  "make_country": "UK"
},
{
  "make_id": "acura",
  "make_display": "Acura",
  "make_country": "USA"
},
{
  "make_id": "alfa-romeo",
  "make_display": "Alfa Romeo",
  "make_country": "Italy"
},
{
  "make_id": "allard",
  "make_display": "Allard",
  "make_country": "UK"
},
{
  "make_id": "alpina",
  "make_display": "Alpina",
  "make_country": "UK"
},
{
  "make_id": "alpine",
  "make_display": "Alpine",
  "make_country": "Germany"
},
{
  "make_id": "alvis",
  "make_display": "Alvis",
  "make_country": "UK"
},
{
  "make_id": "amc",
  "make_display": "AMC",
  "make_country": "USA"
},
{
  "make_id": "ariel",
  "make_display": "Ariel",
  "make_country": "UK"
},
{
  "make_id": "armstrong-siddeley",
  "make_display": "Armstrong Siddeley",
  "make_country": "UK"
},
{
  "make_id": "ascari",
  "make_display": "Ascari",
  "make_country": "UK"
},
{
  "make_id": "aston-martin",
  "make_display": "Aston Martin",
  "make_country": "UK"
},
{
  "make_id": "audi",
  "make_display": "Audi",
  "make_country": "Germany"
},
{
  "make_id": "austin",
  "make_display": "Austin",
  "make_country": "UK"
},
{
  "make_id": "austin-healey",
  "make_display": "Austin-Healey",
  "make_country": "UK"
},
{
  "make_id": "autobianchi",
  "make_display": "Autobianchi",
  "make_country": "Italy"
},
{
  "make_id": "auverland",
  "make_display": "Auverland",
  "make_country": "France"
},
{
  "make_id": "avanti",
  "make_display": "Avanti",
  "make_country": "USA"
},
{
  "make_id": "beijing",
  "make_display": "Beijing",
  "make_country": "China"
},
{
  "make_id": "bentley",
  "make_display": "Bentley",
  "make_country": "UK"
},
{
  "make_id": "berkeley",
  "make_display": "Berkeley",
  "make_country": "UK"
},
{
  "make_id": "bitter",
  "make_display": "Bitter",
  "make_country": "Germany"
},
{
  "make_id": "bizzarrini",
  "make_display": "Bizzarrini",
  "make_country": "Italy"
},
{
  "make_id": "bmw",
  "make_display": "BMW",
  "make_country": "Germany"
},
{
  "make_id": "brilliance",
  "make_display": "Brilliance",
  "make_country": "China"
},
{
  "make_id": "bristol",
  "make_display": "Bristol",
  "make_country": "UK"
},
{
  "make_id": "bugatti",
  "make_display": "Bugatti",
  "make_country": "Italy"
},
{
  "make_id": "buick",
  "make_display": "Buick",
  "make_country": "USA"
},
{
  "make_id": "cadillac",
  "make_display": "Cadillac",
  "make_country": "USA"
},
{
  "make_id": "caterham",
  "make_display": "Caterham",
  "make_country": "UK"
},
{
  "make_id": "checker",
  "make_display": "Checker",
  "make_country": "USA"
},
{
  "make_id": "chevrolet",
  "make_display": "Chevrolet",
  "make_country": "USA"
},
{
  "make_id": "chrysler",
  "make_display": "Chrysler",
  "make_country": "USA"
},
{
  "make_id": "citroen",
  "make_display": "Citroen",
  "make_country": "France"
},
{
  "make_id": "dacia",
  "make_display": "Dacia",
  "make_country": "Romania"
},
{
  "make_id": "daewoo",
  "make_display": "Daewoo",
  "make_country": "South Korea"
},
{
  "make_id": "daf",
  "make_display": "DAF",
  "make_country": "Netherlands"
},
{
  "make_id": "daihatsu",
  "make_display": "Daihatsu",
  "make_country": "Japan"
},
{
  "make_id": "daimler",
  "make_display": "Daimler",
  "make_country": "UK"
},
{
  "make_id": "datsun",
  "make_display": "Datsun",
  "make_country": "Japan"
},
{
  "make_id": "de-tomaso",
  "make_display": "De Tomaso",
  "make_country": "Italy"
},
{
  "make_id": "dkw",
  "make_display": "DKW",
  "make_country": "Germany"
},
{
  "make_id": "dodge",
  "make_display": "Dodge",
  "make_country": "USA"
},
{
  "make_id": "donkervoort",
  "make_display": "Donkervoort",
  "make_country": "Netherlands"
},
{
  "make_id": "eagle",
  "make_display": "Eagle",
  "make_country": "USA"
},
{
  "make_id": "fairthorpe",
  "make_display": "Fairthorpe",
  "make_country": "UK"
},
{
  "make_id": "ferrari",
  "make_display": "Ferrari",
  "make_country": "Italy"
},
{
  "make_id": "fiat",
  "make_display": "Fiat",
  "make_country": "Italy"
},
{
  "make_id": "fisker",
  "make_display": "Fisker",
  "make_country": "USA"
},
{
  "make_id": "ford",
  "make_display": "Ford",
  "make_country": "USA"
},
{
  "make_id": "gaz",
  "make_display": "GAZ",
  "make_country": "Russia"
},
{
  "make_id": "geely",
  "make_display": "Geely",
  "make_country": "China"
},
{
  "make_id": "ginetta",
  "make_display": "Ginetta",
  "make_country": "UK"
},
{
  "make_id": "gmc",
  "make_display": "GMC",
  "make_country": "USA"
},
{
  "make_id": "holden",
  "make_display": "Holden",
  "make_country": "Australia"
},
{
  "make_id": "honda",
  "make_display": "Honda",
  "make_country": "Japan"
},
{
  "make_id": "hudson",
  "make_display": "Hudson",
  "make_country": "USA"
},
{
  "make_id": "humber",
  "make_display": "Humber",
  "make_country": "UK"
},
{
  "make_id": "hummer",
  "make_display": "Hummer",
  "make_country": "USA"
},
{
  "make_id": "hyundai",
  "make_display": "Hyundai",
  "make_country": "South Korea"
},
{
  "make_id": "infiniti",
  "make_display": "Infiniti",
  "make_country": "Japan"
},
{
  "make_id": "innocenti",
  "make_display": "Innocenti",
  "make_country": "Italy"
},
{
  "make_id": "isuzu",
  "make_display": "Isuzu",
  "make_country": "Japan"
},
{
  "make_id": "italdesign",
  "make_display": "Italdesign",
  "make_country": "Italy"
},
{
  "make_id": "jaguar",
  "make_display": "Jaguar",
  "make_country": "UK"
},
{
  "make_id": "jeep",
  "make_display": "Jeep",
  "make_country": "USA"
},
{
  "make_id": "jensen",
  "make_display": "Jensen",
  "make_country": "UK"
},
{
  "make_id": "kia",
  "make_display": "Kia",
  "make_country": "South Korea"
},
{
  "make_id": "koenigsegg",
  "make_display": "Koenigsegg",
  "make_country": "Sweden"
},
{
  "make_id": "lada",
  "make_display": "Lada",
  "make_country": "Russia"
},
{
  "make_id": "lamborghini",
  "make_display": "Lamborghini",
  "make_country": "Italy"
},
{
  "make_id": "lancia",
  "make_display": "Lancia",
  "make_country": "Italy"
},
{
  "make_id": "land-rover",
  "make_display": "Land Rover",
  "make_country": "UK"
},
{
  "make_id": "lexus",
  "make_display": "Lexus",
  "make_country": "Japan"
},
{
  "make_id": "lincoln",
  "make_display": "Lincoln",
  "make_country": "USA"
},
{
  "make_id": "lotec",
  "make_display": "Lotec",
  "make_country": "Germany"
},
{
  "make_id": "lotus",
  "make_display": "Lotus",
  "make_country": "UK"
},
{
  "make_id": "luxgen",
  "make_display": "Luxgen",
  "make_country": "Taiwan"
},
{
  "make_id": "mahindra",
  "make_display": "Mahindra",
  "make_country": "India"
},
{
  "make_id": "marcos",
  "make_display": "Marcos",
  "make_country": "UK"
},
{
  "make_id": "maserati",
  "make_display": "Maserati",
  "make_country": "Italy"
},
{
  "make_id": "matra-simca",
  "make_display": "Matra-Simca",
  "make_country": "France"
},
{
  "make_id": "maybach",
  "make_display": "Maybach",
  "make_country": "Germany"
},
{
  "make_id": "mazda",
  "make_display": "Mazda",
  "make_country": "Japan"
},
{
  "make_id": "mcc",
  "make_display": "MCC",
  "make_country": "Germany"
},
{
  "make_id": "mclaren",
  "make_display": "McLaren",
  "make_country": "UK"
},
{
  "make_id": "mercedes-benz",
  "make_display": "Mercedes-Benz",
  "make_country": "Germany"
},
{
  "make_id": "mercury",
  "make_display": "Mercury",
  "make_country": "USA"
},
{
  "make_id": "mg",
  "make_display": "MG",
  "make_country": "UK"
},
{
  "make_id": "mini",
  "make_display": "Mini",
  "make_country": "UK"
},
{
  "make_id": "mitsubishi",
  "make_display": "Mitsubishi",
  "make_country": "Japan"
},
{
  "make_id": "monteverdi",
  "make_display": "Monteverdi",
  "make_country": "Switzerland"
},
{
  "make_id": "moretti",
  "make_display": "Moretti",
  "make_country": "Italy"
},
{
  "make_id": "morgan",
  "make_display": "Morgan",
  "make_country": "UK"
},
{
  "make_id": "morris",
  "make_display": "Morris",
  "make_country": "UK"
},
{
  "make_id": "nissan",
  "make_display": "Nissan",
  "make_country": "Japan"
},
{
  "make_id": "noble",
  "make_display": "Noble",
  "make_country": "UK"
},
{
  "make_id": "nsu",
  "make_display": "NSU",
  "make_country": "Germany"
},
{
  "make_id": "oldsmobile",
  "make_display": "Oldsmobile",
  "make_country": "USA"
},
{
  "make_id": "opel",
  "make_display": "Opel",
  "make_country": "Germany"
},
{
  "make_id": "packard",
  "make_display": "Packard",
  "make_country": "USA"
},
{
  "make_id": "pagani",
  "make_display": "Pagani",
  "make_country": "Italy"
},
{
  "make_id": "panoz",
  "make_display": "Panoz",
  "make_country": "USA"
},
{
  "make_id": "peugeot",
  "make_display": "Peugeot",
  "make_country": "France"
},
{
  "make_id": "pininfarina",
  "make_display": "Pininfarina",
  "make_country": "Italy"
},
{
  "make_id": "plymouth",
  "make_display": "Plymouth",
  "make_country": "USA"
},
{
  "make_id": "pontiac",
  "make_display": "Pontiac",
  "make_country": "USA"
},
{
  "make_id": "porsche",
  "make_display": "Porsche",
  "make_country": "Germany"
},
{
  "make_id": "proton",
  "make_display": "Proton",
  "make_country": "Malaysia"
},
{
  "make_id": "reliant",
  "make_display": "Reliant",
  "make_country": "UK"
},
{
  "make_id": "renault",
  "make_display": "Renault",
  "make_country": "France"
},
{
  "make_id": "riley",
  "make_display": "Riley",
  "make_country": "UK"
},
{
  "make_id": "rolls-royce",
  "make_display": "Rolls-Royce",
  "make_country": "UK"
},
{
  "make_id": "rover",
  "make_display": "Rover",
  "make_country": "UK"
},
{
  "make_id": "saab",
  "make_display": "Saab",
  "make_country": "Sweden"
},
{
  "make_id": "saleen",
  "make_display": "Saleen",
  "make_country": "USA"
},
{
  "make_id": "samsung",
  "make_display": "Samsung",
  "make_country": "South Korea"
},
{
  "make_id": "saturn",
  "make_display": "Saturn",
  "make_country": "USA"
},
{
  "make_id": "scion",
  "make_display": "Scion",
  "make_country": "Japan"
},
{
  "make_id": "seat",
  "make_display": "Seat",
  "make_country": "Spain"
},
{
  "make_id": "simca",
  "make_display": "Simca",
  "make_country": "France"
},
{
  "make_id": "singer",
  "make_display": "Singer",
  "make_country": "UK"
},
{
  "make_id": "skoda",
  "make_display": "Skoda",
  "make_country": "Czech Republic"
},
{
  "make_id": "smart",
  "make_display": "Smart",
  "make_country": "France"
},
{
  "make_id": "spyker",
  "make_display": "Spyker",
  "make_country": "Netherlands"
},
{
  "make_id": "ssangyong",
  "make_display": "SsangYong",
  "make_country": "South Korea"
},
{
  "make_id": "ssc",
  "make_display": "SSC",
  "make_country": "USA"
},
{
  "make_id": "steyr",
  "make_display": "Steyr",
  "make_country": "Austria"
},
{
  "make_id": "studebaker",
  "make_display": "Studebaker",
  "make_country": "USA"
},
{
  "make_id": "subaru",
  "make_display": "Subaru",
  "make_country": "Japan"
},
{
  "make_id": "sunbeam",
  "make_display": "Sunbeam",
  "make_country": "UK"
},
{
  "make_id": "suzuki",
  "make_display": "Suzuki",
  "make_country": "Japan"
},
{
  "make_id": "talbot",
  "make_display": "Talbot",
  "make_country": "UK"
},
{
  "make_id": "tata",
  "make_display": "Tata",
  "make_country": "India"
},
{
  "make_id": "tatra",
  "make_display": "Tatra",
  "make_country": "Czech Republic"
},
{
  "make_id": "tesla",
  "make_display": "Tesla",
  "make_country": "USA"
},
{
  "make_id": "toyota",
  "make_display": "Toyota",
  "make_country": "Japan"
},
{
  "make_id": "trabant",
  "make_display": "Trabant",
  "make_country": "Germany"
},
{
  "make_id": "triumph",
  "make_display": "Triumph",
  "make_country": "UK"
},
{
  "make_id": "tvr",
  "make_display": "TVR",
  "make_country": "UK"
},
{
  "make_id": "vauxhall",
  "make_display": "Vauxhall",
  "make_country": "Germany"
},
{
  "make_id": "vector",
  "make_display": "Vector",
  "make_country": "Japan"
},
{
  "make_id": "venturi",
  "make_display": "Venturi",
  "make_country": "France"
},
{
  "make_id": "volkswagen",
  "make_display": "Volkswagen",
  "make_country": "Germany"
},
{
  "make_id": "volvo",
  "make_display": "Volvo",
  "make_country": "Sweden"
},
{
  "make_id": "wartburg",
  "make_display": "Wartburg",
  "make_country": "Germany"
},
{
  "make_id": "westfield",
  "make_display": "Westfield",
  "make_country": "UK"
},
{
  "make_id": "willys-overland",
  "make_display": "Willys-Overland",
  "make_country": "USA"
},
{
  "make_id": "xedos",
  "make_display": "Xedos",
  "make_country": "Japan"
},
{
  "make_id": "zagato",
  "make_display": "Zagato",
  "make_country": "Italy"
},
{
  "make_id": "zastava",
  "make_display": "Zastava",
  "make_country": "Serbia"
},
{
  "make_id": "zaz",
  "make_display": "ZAZ",
  "make_country": "Ukraine"
},
{
  "make_id": "zenvo",
  "make_display": "Zenvo",
  "make_country": "Denmark"
},
{
  "make_id": "zil",
  "make_display": "ZIL",
  "make_country": "Russia"
}
]